module.exports = __webpack_public_path__ + "static/assets/9bdc0c22fc63049cd8f4b34daa259031.svg";